import arrow from '@assets/svg/playersTab/arrow-down.svg';
import { useLanguage } from '@utils/hooks/useLanguage';
import { useTranslations } from '../../../../../translation/TranslationContext';

export const ShowAllButton = ({ isShowAllOpen, setIsShowAllOpen }: { isShowAllOpen: boolean; setIsShowAllOpen: (isShowAllOpen: boolean) => void }) => {
    const language = useLanguage();
    const t = useTranslations(language);
    
    return (
        <>
            {!isShowAllOpen ? (
                <div 
                  className="bg-transparent w-full h-[16px] flex justify-center items-center text-[12px] mb-[24px]
                      text-base0 dark:text-base090 font-robotoMedium font-medium"
                >
                <div className='px-5 flex flex-row justify-center items-center cursor-pointer'
                onClick={() => setIsShowAllOpen(!isShowAllOpen)}>
                  {!isShowAllOpen && t['InHouseStats.PlayersShowAll']}
                  <img src={arrow} alt="arrow" className="w-[12px] h-[12px] ml-[4px]" />
                </div>
            </div>
        ) : (
            <div className="h-[16px]"></div>
            )}
        </>
    )
}